import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';

import dashboardReducer from './dashboard/data/reducer';
import dashboardSaga from './dashboard/data/sagas';
import listPageReducer from './listPage/data/reducer';
import listPageSagas from './listPage/data/sagas';
import routes from './routes';

const reducer = combineReducers({
  dashboard: dashboardReducer,
  listPage: listPageReducer,
});

const saga = function* () {
  yield all([dashboardSaga(), listPageSagas()]);
};

export { reducer, routes, saga };
